import { jsx as H } from "react/jsx-runtime";
import { checkGoogleReCaptchaInjected as j, injectGoogleReCaptchaScript as O, removeGoogleReCaptchaScript as W, removeGoogleReCaptchaContainer as z, removeGoogleReCaptchaBadge as L, hideGoogleReCaptchaBadge as M } from "@google-recaptcha/core";
import { useState as k, useEffect as N, useMemo as $ } from "react";
import { GoogleReCaptchaContext as q } from "./GoogleReCaptchaContext.mjs";
const D = "onGoogleReCaptchaLoad", E = "google-recaptcha-container", X = ({
  type: r,
  siteKey: n,
  language: d,
  scriptProps: f,
  isEnterprise: v = !1,
  host: m,
  theme: G = "light",
  children: R,
  explicit: o,
  onLoad: s,
  onError: u
}) => {
  const [w, h] = k(!0), [e, g] = k();
  N(() => {
    const b = (f == null ? void 0 : f.id) ?? `google-recaptcha-${r}-script`, c = j(), t = () => {
      var C;
      h(!0);
      const a = v ? (C = window.grecaptcha) == null ? void 0 : C.enterprise : window.grecaptcha;
      if (!a) {
        u && u();
        return;
      }
      if (o || a.ready(async () => {
        g(a), s && await s(a), h(!1);
      }), o) {
        const B = {
          size: r === "v3" || r === "v2-invisible" ? "invisible" : "normal",
          ...(r === "v3" || r === "v2-invisible") && { badge: "bottomright" },
          sitekey: n,
          theme: G,
          ...typeof o == "object" && {
            ...o,
            "expired-callback": o.expiredCallback,
            "error-callback": o.errorCallback
          }
        };
        c || typeof o == "object" && (r === "v3" || r === "v2-invisible") && (o == null ? void 0 : o.badge) === "hidden" && M(), a.ready(async () => {
          typeof o == "object" && o.container && a.render(o.container, B, !!o.inherit), g(a), s && await s(a), h(!1);
        });
      }
    };
    return window[D] = t, c ? t() : O({
      isEnterprise: v,
      host: m,
      ...(r === "v3" || r === "v2-invisible") && typeof o == "object" && (o == null ? void 0 : o.badge) && {
        badge: (o == null ? void 0 : o.badge) === "hidden" ? "bottomright" : o == null ? void 0 : o.badge
      },
      ...d && { hl: d },
      render: o || r === "v2-checkbox" ? "explicit" : n,
      ...f,
      onload: t,
      id: b
    }), () => {
      j() && W(), typeof o == "object" && (r === "v3" || r === "v2-invisible") && !(o != null && o.container) && (o != null && o.badge) ? z(E) : L();
    };
  }, [v, d, m, n, r]);
  const V = (b) => {
    if (!(e != null && e.execute)) throw new Error("Google ReCaptcha has not been loaded");
    return e.execute(n, { action: b });
  }, S = (b) => {
    if (!(e != null && e.execute)) throw new Error("Google ReCaptcha has not been loaded");
    return e.execute(b);
  }, A = $(
    () => ({
      instance: e,
      siteKey: n,
      isLoading: w,
      theme: G,
      executeV2Invisible: S,
      executeV3: V,
      reset: e == null ? void 0 : e.reset,
      getResponse: e == null ? void 0 : e.getResponse,
      render: e == null ? void 0 : e.render,
      ...d && { language: d }
    }),
    [e, n, w, d]
  );
  return /* @__PURE__ */ H(q.Provider, { value: A, children: R });
};
export {
  X as GoogleReCaptchaProvider
};
//# sourceMappingURL=GoogleReCaptchaProvider.mjs.map
